import React from 'react';
import Icon from '../../../components/AppIcon';

const DeliveryInfoCard = ({ selectedZone, deliveryFee, estimatedTime }) => {
  const deliveryZones = [
    { id: 1, name: "Juba City Center", fee: 500, time: "20-30 min" },
    { id: 2, name: "Gudele", fee: 800, time: "30-40 min" },
    { id: 3, name: "Konyokonyo", fee: 700, time: "25-35 min" },
    { id: 4, name: "Munuki", fee: 900, time: "35-45 min" },
    { id: 5, name: "Jebel", fee: 1000, time: "40-50 min" }
  ];

  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6 lg:p-8 mb-4 md:mb-6 lg:mb-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name="Truck" size={20} color="var(--color-accent)" />
        </div>
        <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Delivery Information</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-6">
        {deliveryZones?.map((zone) => (
          <div
            key={zone?.id}
            className={`p-3 md:p-4 rounded-lg border-2 transition-all cursor-pointer ${
              selectedZone === zone?.id
                ? 'border-accent bg-accent/10' :'border-border hover:border-accent/50'
            }`}
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <h3 className="font-semibold text-foreground text-sm md:text-base">{zone?.name}</h3>
              {selectedZone === zone?.id && (
                <Icon name="CheckCircle2" size={18} color="var(--color-accent)" />
              )}
            </div>
            <div className="space-y-1">
              <p className="text-xs md:text-sm text-muted-foreground flex items-center gap-1">
                <Icon name="Banknote" size={14} />
                SSP {zone?.fee?.toLocaleString()}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground flex items-center gap-1">
                <Icon name="Clock" size={14} />
                {zone?.time}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-muted/50 rounded-lg p-3 md:p-4 space-y-2 md:space-y-3">
        <div className="flex items-center gap-2 text-sm md:text-base">
          <Icon name="MapPin" size={18} color="var(--color-primary)" />
          <span className="text-foreground font-semibold">Current Delivery Zone:</span>
          <span className="text-muted-foreground">
            {selectedZone ? deliveryZones?.find(z => z?.id === selectedZone)?.name : 'Not selected'}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm md:text-base">
          <Icon name="Banknote" size={18} color="var(--color-primary)" />
          <span className="text-foreground font-semibold">Delivery Fee:</span>
          <span className="text-muted-foreground">SSP {deliveryFee?.toLocaleString()}</span>
        </div>
        <div className="flex items-center gap-2 text-sm md:text-base">
          <Icon name="Clock" size={18} color="var(--color-primary)" />
          <span className="text-foreground font-semibold">Estimated Time:</span>
          <span className="text-muted-foreground">{estimatedTime}</span>
        </div>
      </div>
      <div className="mt-4 md:mt-6 p-3 md:p-4 bg-accent/10 rounded-lg border border-accent/30">
        <div className="flex gap-2 md:gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="text-xs md:text-sm text-foreground">
            <p className="font-semibold mb-1">Free delivery on orders above SSP 5,000!</p>
            <p className="text-muted-foreground">Delivery times may vary based on traffic and weather conditions.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfoCard;